import React from 'react'

import { useRegisterBootstrapLoading } from 'components/bootstrap-loader/use-bootstrap-loading'

/**
 * Router's hydrateFallbackElement on a cold deep-link (see routes/Router.tsx)
 * — react-router renders this in place of the page while the first lazy
 * route chunk is in flight. Registers into the same bootstrap-loading
 * registry as the auth/projects/project gates instead of rendering its own
 * loader, so GlobalBootstrapOverlay stays the single loading surface across
 * the whole refresh with no hand-off between separate loading elements.
 */
export const RouteHydrateGate: React.FC = () => {
  useRegisterBootstrapLoading('hydrate', true)
  return null
}
